import Common from '../../../Common';
import Callers from './queue/Callers';

const Queue = class extends Common {
	callers: InstanceType<typeof Callers>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.callers = new Callers(headers)
	}
}

export default Queue
